'use client';

import { useRef } from 'react';
import { ChevronDown } from 'lucide-react';

export default function WhatsInspiringOurWorkContent() {
  const secondSectionRef = useRef<HTMLElement>(null);

  const scrollToNextSection = () => {
    secondSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
      <main className="relative ">
          {/* First Section - Full Screen Image (slide11.jpg) */}
          <section
              id="time"
              className="scroll-mt-20 w-full bg-[#fcfaeb] text-center px-2 md:px-6 pt-20 md:pt-24 pb-6 md:pb-20"
          ><h1
              className="text-[#e25f4c] text-4xl md:text-6xl lg:text-7xl font-semibold tracking-normal md:tracking-wider mb-4 md:mb-8">
              Time
          </h1>

              <p className="text-[#e25f4c] text-lg md:text-2xl lg:text-3xl tracking-normal md:tracking-wide leading-snug md:leading-loose mb-6 md:mb-16">
                  Learnings from best practice from the world.
              </p>

              {/* Logos in a row */}
              <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-10 mb-6 md:mb-16">
                  <img src="/page5/2hourLearning.svg" alt="2 Hour Learning" className="h-28 md:h-32"/>
                  <img src="/page5/kairos3.png" alt="Kairos Academies" className="h-28 md:h-32"/>
                  <img
                      src="/page5/flourish_academy.jpg"
                      alt="Flourish School"
                      className="h-28 md:h-32 w-32 object-contain"
                  /></div>

              <p className="text-[#e25f4c] text-base md:text-2xl lg:text-4xl tracking-normal md:tracking-wide leading-snug md:leading-loose px-2 md:px-4">
                  Students spend 50–60% of their time completing content, in a self-paced learning format.
                  <br/>
                  They still achieve top 1% outcomes in their region.
              </p>

          </section>

          <section className="w-full bg-[#fcfaeb] text-center px-2 md:px-6 py-6 md:py-20">
              <h1 className="text-[#e25f4c] text-4xl md:text-6xl lg:text-7xl font-semibold tracking-wider mb-4 md:mb-8">
                  Content
              </h1>

              <p className="text-[#e25f4c] text-lg md:text-2xl lg:text-3xl tracking-wide leading-snug md:leading-loose mb-6 md:mb-12">
                  Learnings from best practice from the world.
              </p>

              {/* Logo + Description */}
              <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-12 mb-6 md:mb-16">
                  <img
                      src="/page5/summit-learning-preview.png"
                      alt="Summit Learning"
                      className="h-28 md:h-36 object-contain"
                  />
                  <p className="text-[#e25f4c] text-base md:text-2xl lg:text-3xl leading-snug md:leading-loose tracking-wide max-w-2xl px-4">
                      A white paper with over 15 years of research,
                      <br/>
                      that highlights the four pillars needed to be college and career ready.
                  </p>
              </div>

              {/* Four Pillars */}
              <div
                  className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-10 text-[#e25f4c] text-base md:text-2xl lg:text-3xl font-medium tracking-wide leading-snug md:leading-loose">
                  <div>
                      <p>Content</p>
                      <p>Mastery</p>
                  </div>
                  <div>
                      <p>Cognitive</p>
                      <p>Skills</p>
                  </div>
                  <div>
                      <p>Habits of</p>
                      <p>Success</p>
                  </div>
                  <div>
                      <p>Sense of</p>
                      <p>Purpose</p>
                  </div>
              </div>

              <p className="text-[#e25f4c] text-xs mt-4 md:mt-6">
                  *Partnership with Stanford Center for Assessment, Learning, and Equity
              </p>
          </section>


      </main>
  );
} 